angular.module('unergie.main')
.directive('overdueTimeline', (DataAccessSearch, ErrorCatcher) => ({
    restrict: 'E',
    scope: {
        contract: '=',
    },
    templateUrl: '/directives/overdueTimeline/overdueTimeline.html',
    link($scope) {
        $scope.state = 0
        const stateMapping = {
            NONE: 0,
            RELANCES_1: 1,
            RELANCES_2: 2,
            RELANCES_3: 3,
            AVERTISSEMENT: 4,
            MISE_EN_DEMEURE: 5,
            COUPURE: 6,
            RESILIATION: 7,
        }
        const overdueStatusMapping = {
            INITIAL: stateMapping.RELANCES_1,
            INITIAL_WAITING_SLIMPAY: stateMapping.RELANCES_1,
            R1_SENT: stateMapping.RELANCES_1,
            R1_SENT_WAITING_SLIMPAY: stateMapping.RELANCES_1,

            SMS1BIS_SENT: stateMapping.RELANCES_2,
            SMS1BIS_SENT_WAITING_SLIMPAY: stateMapping.RELANCES_2,

            SMS1TER_SENT: stateMapping.RELANCES_3,
            SMS1TER_SENT_WAITING_SLIMPAY: stateMapping.RELANCES_3,

            R2_SENT: stateMapping.AVERTISSEMENT,
            R2_SENT_WAITING_SLIMPAY: stateMapping.AVERTISSEMENT,
            ENERGY_CHECK_CHECKED: stateMapping.AVERTISSEMENT,
            ENERGY_CHECK_CHECKED_WAITING_SLIMPAY: stateMapping.AVERTISSEMENT,
            R3_SENT: stateMapping.AVERTISSEMENT,

            LRAR_WS_SENT: stateMapping.MISE_EN_DEMEURE,
            LRAR_WS_SENT_WAITING_SLIMPAY: stateMapping.MISE_EN_DEMEURE,

            MANUAL_LIMITATION: stateMapping.COUPURE,
            MANUAL_OUTAGE: stateMapping.COUPURE,
            R4_SENT: stateMapping.COUPURE,
            R4_SENT_WAITING_SLIMPAY: stateMapping.COUPURE,
            STARTED_REDUC_OUTAGE_PROCESS: stateMapping.COUPURE,
            ON_HOLD: stateMapping.COUPURE,
            SUSPENSION_REQUESTED: stateMapping.COUPURE,
            LIMITATION_REQUESTED: stateMapping.COUPURE,
            SUSPENDED: stateMapping.COUPURE,
            LIMITED: stateMapping.COUPURE,
            RESTORATION_REQUESTED: stateMapping.COUPURE,
        }

        const fetchOverdue = () => {
            DataAccessSearch({
                eq: ['process_name=Overdue', 'process_name=OverdueV2', 'process_name=OverdueV3'],
                neq: ['status=TERMINATED'],
                unlike: ['status=CANCELLED_', 'status=FINISHED_'],
            }).searchPaginated({
                resource: 'overdue-processes',
                id_contract: $scope.contract.id,
            }).$promise.then((data) => {
                if (!_.isEmpty(data.results)) {
                    if ($scope.contract.status === 14) {
                        $scope.state = stateMapping.RESILIATION
                    } else {
                        $scope.state = _.get(overdueStatusMapping, _.get(data, 'results[0].status'), stateMapping.NONE)
                    }
                }
            }).catch(ErrorCatcher)
        }

        const activate = () => {
            fetchOverdue()
        }
        activate()
    },
}))
